import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { TarotProvider } from './context/TarotContext';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import ReadingPage from './pages/ReadingPage';
import HistoryPage from './pages/HistoryPage';
import { PredictionList } from './components/prediccion/PredictionList';
import { PredictionDetail } from './components/prediccion/PredictionDetail';
import './styles/App.css';

function App() {
  return (
    <AuthProvider>
      <TarotProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/reading" element={<ReadingPage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/prediccion-diaria" element={<PredictionList />} />
            <Route path="/prediccion-diaria/:id" element={<PredictionDetail />} />
          </Routes>
        </div>
      </TarotProvider>
    </AuthProvider>
  );
}

export default App;
